import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { CommonHttpModule } from "../../providers/commonHttpModule";
import { MaPurpose } from "src/app/modules/Disbursment_modules/dis-repository/pages/create-purpose/purpose.model";

@Injectable({
  providedIn: 'root'
})
export class PurposeService {
  constructor(private http: CommonHttpModule) {

  }

  // method to get the data from db
  purposeDataFromDb(body: any): Observable<{ total_count: number, data: MaPurpose[] }> {
    return this.http.post<{ total_count: number, data: MaPurpose[] }>("purposelist", body).pipe(
      map(response => ({
        total_count: response.total_count,
        data: response.data
      })
      ));
  }

  // method to send the data to db
  purposeDataToDb(data: MaPurpose) {
    return this.http.post("create-updatePurpose", data).pipe(map(response => {
      return response;
    }))
  }

  getMaPurpose(params: {}): Observable<MaPurpose[]> {
    return this.http.post<{ purpose: MaPurpose[] }>(
      'getmaster-data',
      params
    ).pipe(
      map(response => response.purpose ?? [])
    );
  }



}